import _ from 'lodash';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js'
import '@fortawesome/fontawesome-free/css/all.css';
import './assets/scss/main.scss';

import Logo  from './assets/images/logo_icon.svg';

function render() {
  const element = document.createElement('div');
  element.id = "root";
  element.innerHTML =_.join([header(), content()], ' ');

  return element;
}

function header(){
  return `<nav class="navbar">
  <span class="navbar-brand">
    <img src=${Logo} class="navbar__logo d-inline-block align-top" alt="Codemasters" /> 
    Codemasters
  </span>
  </nav>`;
}

function content(){
  return `<main class="main">
    <div class="main__content">
      <div class="main__content--wrapper">    
      <img src=${Logo} class="main__content--logo" alt="Codemasters" />
          <p class="main__content--text">We're down for a little maintenance and should be back shortly</p>
          <ul class="main__content--social">
            <li>
              <a href=${config.twitterUrl} target="_blank" rel="noopener noreferrer"><i class="fab fa-twitter"></i></a>
            </li>
            <li> 
              <a href=${config.facebookUrl} target="_blank" rel="noopener noreferrer"><i class="fab fa-facebook"></i></a>
            </li>
            <li>
            <a href=${config.youtubeUrl} target="_blank" rel="noopener noreferrer"><i class="fab fa-youtube"></i></a>
            </li>
          </ul>
      </div>
    </div>
  </main>`;
}


document.body.appendChild(render());